import { Menu } from "@headlessui/react"
import Translation from "components/Translation"
import { classNames } from "utils/dom-helpers"
import GenericSingleSelector from "."
import getConfig from "next/config"


export type SortOption = {
    tag: string
    sort_query: string
    icon?: string
}

type GenericSortProps = {
    options: SortOption[]
    sort_option?: SortOption
    setSortOption(option: SortOption): void
    name: string
}


export default function GenericSort(props: GenericSortProps) {
    const {
        options,
        sort_option,
        setSortOption,
        name
    } = props
    const { NEXT_PUBLIC_STATIC_DOMAIN } = getConfig().publicRuntimeConfig

    return (
        <GenericSingleSelector
            items={options}
            options_class_name="w-fit"
            button_class_name="border-none shadow-none"
            selected_item={sort_option}
            titleDisplay={() => {
                return (
                    <>
                        <Translation content_key={name} />
                        <img src={`https://${NEXT_PUBLIC_STATIC_DOMAIN}/images/sort.svg`} alt="sort" className="ml-2" />
                    </>
                )
            }}
            itemDisplay={(item: SortOption, index: number, is_selected: boolean) => {
                return (
                    <Menu.Item key={item.sort_query}>
                        {({ active }) => (
                            <div
                                className={classNames(
                                    active
                                        ? 'bg-[#86C5E0]/10'
                                        : 'bg-white',
                                    'flex flex-row text-xs items-center font-medium font-[#58595B] p-2 rounded-lg whitespace-nowrap normal-case cursor-pointer',
                                )}
                                onClick={() => {
                                    setSortOption(item)
                                }}
                            >
                                {item.icon && 
                                    <i className={item.icon} />
                                } 
                                <Translation content_key={item.tag || ""} />
                            </div>
                        )}
                    </Menu.Item>
                )
            }}
            isItemSelected={(item: SortOption, selected_item: SortOption) => item.sort_query == selected_item.sort_query}
        />
    )
}